import React from "react";
import "../../../css/TotalAll.css";
import mobility from "../../../img/ride.png";

interface TotalAllProps {
  TotalAll: number;
}

const TotalAll = ({ TotalAll }: TotalAllProps) => {
  return (
    <div className="total_all_container">
      <div className="total_all_display">
        <img className="mobility" src={mobility} />
        <div className="total_all_title">累計ライド金額</div>
      </div>
      <div className="total_all_of">
        {TotalAll.toLocaleString()}
        <span className="unit">円</span>
      </div>
    </div>
  );
};

export default TotalAll;
